module.exports = __webpack_public_path__ + "static/media/kv-social-care.fb6ed407.png";